import React from "react";
import { ContactInput } from "../../style/common.style";

export default function CustomInput(props) {
  return <ContactInput {...props}></ContactInput>;
}
